
export default {
    props: {
        dashboardLocations: {
            type: Object,
            default: {}
        }
    },
}
